<template>
  <div class="magazine-edition-texts">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <b-table
            :fields="fields"
            :items="data"
            :per-page="0"
            :current-page="currentPage"
          >
            <template v-slot:cell(text)="data">
              <i
                class="fa fa-trash-o deleteIcon"
                aria-hidden="true"
                v-on:click="destroy(data.item.id)"
              ></i>
            </template>
          </b-table>
          <div class="no-data" v-if="data.length == 0">
            <span>Sem dados</span>
          </div>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Swal from "sweetalert2";

export default {
  name: "magazine-edition-texts",
  props: {
    magazine_edition_id: Number
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      data: [],
      fields: [
        { key: "id", label: "Código" },
        { key: "text.title", label: "Texto" },
        { key: "text", label: "Opções" }
      ]
    };
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  mounted() {
    this.providerData();
  },
  methods: {
    providerData() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/text_magazine_editions?${this.urlBuild()}`
        )
        .then(response => {
          this.rows = response.data.total;
          this.data = response.data.data;
        });
    },
    urlBuild: function() {
      let url =
        "include=text&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        `&filter[magazine_edition_id]=${this.magazine_edition_id}`;

      return url;
    },
    destroy: function(id) {
      Swal.fire({
        title: "Você tem certeza que deseja excluir esse item?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.value) {
          let promise = axios.delete(
            `${process.env.VUE_APP_API_HOST}/api/text_magazine_editions/${id}`
          );

          promise.then(response => {
            Swal.fire({
              title: "Item excluído com sucesso",
              icon: "success",
              onClose: () => {
                this.providerData();
              }
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.magazine-edition-texts {
  .deleteIcon {
    color: $red_primary;
    font-size: 22px;
    margin-left: 8px;
  }
  .deleteIcon:hover {
    cursor: pointer;
  }
}
</style>